/*global Ractive*/
const jsonToCsv = require('@isoftdata/json-to-csv')
const { pluralIfNeeded: plural } = require('@isoftdata/utility-string')
const makeItButton = require('@isoftdata/button')

module.exports = function createTableCardFooterComponent() {
	return Ractive.extend({
		template: require('./index.html'),
		isolated: true,
		components: {
			itButton: makeItButton(),
		},
		attributes: {
			required: [ 'selectedIds', 'items' ],
			optional: [
				'idKey',
				'showCount',
				'showExportAll',
				'showExportSelected',
				'showClearSelection',
				'exportFileName',
				'exportButtonClass',
				'clearSelectionButtonClass',
				'itemDescriptor',
				'countDescriptor',
			],
		},
		data() {
			return {
				selectedIds: [],
				items: [],
				idKey: 'id',
				showCount: true,
				showExportAll: true,
				showExportSelected: true,
				showClearSelection: true,
				exportFileName: 'list-export',
				exportButtonClass: 'btn-outline-primary',
				clearSelectionButtonClass: 'btn-outline-warning',
				itemDescriptor: 'List',
				countDescriptor: 'Item',
				plural,
			}
		},
		computed: {
			itemsCSV() {
				const items = this.get('items')

				if (items && items.length > 0) {
					return URL.createObjectURL(new Blob([ jsonToCsv(items) ]))
				}
				return false
			},
			selectedItemsCSV() {
				const items = this.get('items')
				const selectedIds = this.get('selectedIds')
				const idKey = this.get('idKey')

				const filteredItems = items
					?.filter(result => selectedIds.includes(result[idKey]))
					?? []

				if (filteredItems && filteredItems.length > 0) {
					const csv = URL.createObjectURL(new Blob([ jsonToCsv(filteredItems) ]))
					return csv
				}

				return false
			},
		},
		oninit() {
			const ractive = this

			ractive.observe('selectedItemsCSV itemsCSV', (newVal, oldObjectURL, keypath) => {
				// Have to revoke the old objectURL to avoid memory leaks
				if (oldObjectURL) {
					URL.revokeObjectURL(oldObjectURL)
				}
			}, { init: false })
		},
	})
}
